import React from 'react'

import { Card as HeroCard, CardContent as HeroCardContent, cn } from '@heroui/react'

interface CardProps extends React.ComponentProps<typeof HeroCard> {
  children: React.ReactNode;
}

export function Card({ children, className, ...props }: CardProps) {
  return (
    <HeroCard
      className={cn(
        "border border-zinc-200 dark:border-zinc-800 overflow-hidden shadow-none",
        className
      )}
      {...props}
    >
      {children}
    </HeroCard>
  )
}

interface CardContentProps extends React.ComponentProps<typeof HeroCardContent> {
  children: React.ReactNode;
}

export function CardContent({ children, className, ...props }: CardContentProps) {
  return (
    <HeroCardContent className={cn(className)} {...props}>
      {children}
    </HeroCardContent>
  )
}

export { CardFooter,CardHeader } from '@heroui/react'
